(() => {
  let panel, widget, mode = '', busy = false, version = 0, timer, error = false;
  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
  const rows = () => [...widget.querySelectorAll('.parcely_app_shipping_method')];
  const status = () => panel.querySelector('.ally-delivery-status');
  const country = () => widget.querySelector('.select_country_row .country_alpha')?.textContent.trim();
  const countryWrapper = () => widget.querySelector('.select_country_row')?.closest('.parcely_app > div');
  const locationValue = () => {
    const inputs = [...widget.querySelectorAll('[role="combobox"]')];
    const location = inputs.find(input => !countryWrapper()?.contains(input));
    return location?.closest('[class$="-container"]')?.querySelector('[class$="-singleValue"]')?.textContent.trim() || '';
  };
  const addressSelected = () => rows()[1]?.querySelector('input')?.checked;
  const pickupSelected = () => rows()[0]?.querySelector('input')?.checked;
  const ready = () => !busy && !error && (mode === 'address' ? addressSelected() : (mode === 'EE' || mode === 'FI') && pickupSelected() && country() === mode && !!locationValue());
  function decorate() {
    rows()[0]?.parentElement.classList.add('ally-native-heading');
    countryWrapper()?.classList.add('ally-native-country');
    const provider = widget.querySelector('.parcely_shipping_provider');
    provider?.parentElement.classList.add('ally-native-providers');
    widget.classList.toggle('ally-choices-waiting', busy || !mode || error);
    widget.dataset.allyMode = mode;
    panel.querySelector('.ally-delivery-suboptions').hidden = !panel.querySelector('[value="international"]').checked;
    panel.querySelectorAll('input').forEach(input => { input.disabled = busy; });
    const text = busy ? status().dataset.loading : error ? status().dataset.error : mode === 'address' ? status().dataset.address : '';
    if (status().textContent !== text) status().textContent = text;
    panel.dispatchEvent(new CustomEvent('ally:shipping-ready', { bubbles: true }));
  }
  async function setCountry(code, token) {
    for (let attempt = 0; attempt < 24 && token === version; attempt++) {
      if (country() === code) return true;
      const input = countryWrapper()?.querySelector('[role="combobox"]');
      if (input) {
        input.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowDown', code: 'ArrowDown', keyCode: 40, which: 40, bubbles: true }));
        await wait(70);
        const option = [...widget.querySelectorAll('[role="option"]')].find(el => el.querySelector('.country_alpha')?.textContent.trim() === code);
        if (option) {
          option.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, button: 0 }));
          option.click();
        }
      }
      await wait(120);
    }
    return country() === code;
  }
  async function clearPickup() {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(root + 'cart.js').then(response => { if (!response.ok) throw new Error('cart'); return response.json(); });
    const attributes = {};
    for (const key of Object.keys(cart.attributes || {})) {
      if (/location|pup_code|parcely|shipping_rate|shipping_method|service_provider/i.test(key)) attributes[key] = '';
    }
    if (Object.keys(attributes).length) {
      const response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }) });
      if (!response.ok) throw new Error('cart-update');
    }
  }
  async function choose(next) {
    const token = ++version;
    busy = true; error = false; mode = next; decorate();
    try {
      rows()[1]?.click();
      await wait(180);
      await clearPickup();
      if (token !== version) return;
      if (next === 'EE' || next === 'FI') {
        rows()[0]?.click();
        if (!await setCountry(next, token)) throw new Error('country');
        await wait(220);
      }
    } catch (e) { error = true; }
    if (token === version) { busy = false; decorate(); }
  }
  function attach() {
    const nextPanel = document.getElementById('allyShippingChoices') || panel;
    const nextWidget = document.getElementById('parcelyWidget');
    const host = document.getElementById('allyParcelyHost');
    if (!nextPanel || !nextWidget || !host || nextWidget.querySelectorAll('.parcely_app_shipping_method').length < 2) return;
    panel = nextPanel;
    if (panel.parentElement !== host) host.prepend(panel);
    if (widget === nextWidget && panel.dataset.bound) { decorate(); return; }
    widget = nextWidget;
    panel.hidden = false;
    panel.dataset.bound = 'true';
    widget.classList.add('ally-choices-active');
    panel.addEventListener('change', event => {
      const input = event.target;
      if (input.name === 'ally-delivery-region') {
        panel.querySelectorAll('[name="ally-delivery-international"]').forEach(el => { el.checked = false; });
        choose(input.value === 'EE' ? 'EE' : '');
      } else if (input.name === 'ally-delivery-international') choose(input.value);
    });
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(decorate, 50);
    });
    observer.observe(widget, { childList: true, subtree: true, characterData: true });
    document.addEventListener('submit', event => {
      if (event.target.querySelector('[name="checkout"]') && !ready()) { event.preventDefault(); event.stopImmediatePropagation(); panel.scrollIntoView({ block: 'center' }); }
    }, true);
    window.AllyShippingChoices = { ready, mode: () => mode };
    panel.querySelector('[name="ally-delivery-region"][value="EE"]').checked = true;
    choose('EE');
  }
  attach();
  setInterval(attach, 900);
})();
